import { useEffect, useMemo } from 'react';
import { NestedIdValue } from '../../../../../../../features/multi-select/use-multi-select';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useAlertStore } from '../../../../../../../store/use-alert-store';
import { useBranchesStore } from '../../../../../../../store/use-branch-store';
import { useImageStore } from '../../../../../../../store/use-image-store';
import { usePromotionStore } from '../../../../../../../store/use-promotion-store';

export const usePromoSettings = () => {
  const { promo, handleUpdatePromo } = usePromotionStore();
  const { fetchBranches, place } = useBranchesStore();
  const { t, getLocale, currentLang } = useLang();
  const { postImage, isLoading } = useImageStore();
  const { add } = useAlertStore();

  useEffect(() => {
    fetchBranches({ is_by_company: true, since_id: 0, n: 1000 });
  }, [fetchBranches]);

  const nestedPlaces: NestedIdValue[] = useMemo(() => {
    const result: NestedIdValue[] = [{ id: 'all', value: t('Все филиалы'), children: [] }];

    place?.forEach((el) => {
      result[0].children?.push({ id: String(el.id), value: getLocale(el.name), children: [] });
    });
    return result;
  }, [place, getLocale, t]);

  const selectedPlaces: NestedIdValue[] = useMemo(() => {
    const found = promo?.places?.map((el) => {
      const foundPlace = place?.find((place) => place.id === Number(el));
      return foundPlace
        ? { id: String(foundPlace.id), value: getLocale(foundPlace.name) }
        : undefined;
    });
    const filtered = found?.filter((el) => el !== undefined) || [];
    return filtered;
  }, [getLocale, place, promo?.places]);

  const handleChangeBranches = (e: NestedIdValue[]) => {
    handleUpdatePromo({ places: e.map((el) => Number(el.id)) });
  };

  const handleChangeImage = (file?: File[]) => {
    if (!file) {
      handleUpdatePromo({ image: undefined });
      return;
    }
    const formData = new FormData();
    formData.append('image', file[0]);
    postImage(formData).then((res) =>
      handleUpdatePromo({ image: { ...promo?.image, ru: res?.normal } }),
    );
  };
  const handleMaxSizeError = () => {
    add({ variant: 'danger', label: t('Максимальный размер файла 2Мб') });
  };

  return {
    promo,
    handleUpdatePromo,
    handleChangeImage,
    handleMaxSizeError,
    t,
    nestedPlaces,
    handleChangeBranches,
    selectedPlaces,
    isLoading,
    currentLang,
  };
};
